import { FC } from 'react';
import { format as dateFnsFormat } from 'date-fns';
import { Intl } from 'lib/window';
import { toDisplayDateFormat } from 'lib/utils/date';

const TIMEZONE = 'Australia/Sydney';

const TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  timeZone: TIMEZONE,
  timeZoneName: 'short',
  hour: 'numeric',
  minute: 'numeric',
  hour12: true,
};

let hasIntlApiThrown = false;

const formatLongWithIntlPI = (date: Date) => {
  const formattedDate = toDisplayDateFormat(date);
  const formattedTime = new Intl.DateTimeFormat('en-US', TIME_FORMAT_OPTIONS).format(date);
  return `${formattedDate} at ${formattedTime}`;
};

const formatLongwithDateFns = (date: Date) => dateFnsFormat(date, "E d MMM, yyyy 'at' h:mm a xxx");

const formatLong = (date: Date) => {
  if (hasIntlApiThrown) {
    return formatLongwithDateFns(date);
  }

  try {
    return formatLongWithIntlPI(date);
  } catch (error) {
    hasIntlApiThrown = true;
    return formatLongwithDateFns(date);
  }
};

interface FormattedDateProps {
  date: string | number | Date;
}

const FormattedDate: FC<FormattedDateProps> = ({ date }) => {
  const dateInst = date instanceof Date ? date : new Date(date);
  return <>{formatLong(dateInst)}</>;
};

export default FormattedDate;
